import axios from 'axios';

import { getAuth } from 'firebase/auth'; // Firebase Auth import

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const MAIN_METER_API_BASE_URL = `${API_BASE_URL}/main-meters`;
const USER_API_BASE_URL = `${API_BASE_URL}/users`;

class SiteService {

    // Token'ı almak için kullanacağımız yardımcı fonksiyon
    async getToken() {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            return await user.getIdToken(); // Firebase'den token alıyoruz
        }
        return null;
    }



    async getMainMeterById(mainMeterId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async createMainMeter(mainMeter) {
        const token = await this.getToken();
        return axios.post(`${MAIN_METER_API_BASE_URL}`, mainMeter, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async updateMainMeter(mainMeterId, mainMeter) {
        const token = await this.getToken();
        return axios.put(`${MAIN_METER_API_BASE_URL}/${mainMeterId}`, mainMeter, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getMainMetersBySite() {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }
    async getPreparationStatus() {
        
        const token = await this.getToken();
        return axios.get(`${USER_API_BASE_URL}/preparation-status`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }


    async deleteMainMeter(mainMeterId) {
        const token = await this.getToken();
        return axios.delete(`${MAIN_METER_API_BASE_URL}/${mainMeterId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getSubMeterById(mainMeterId, subMeterId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async createSubMeter(mainMeterId, subMeter) {
        const token = await this.getToken();
        return axios.post(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters`, subMeter, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async updateSubMeter(mainMeterId, subMeterId, subMeter) {
        const token = await this.getToken();
        return axios.put(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}`, subMeter, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getSubMetersByMainMeter(mainMeterId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async deleteSubMeter(mainMeterId, subMeterId) {
        const token = await this.getToken();
        return axios.delete(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    // Invoice
    async getInvoiceById(mainMeterId, invoiceId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/${invoiceId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async createInvoice(mainMeterId, invoice) {
        const token = await this.getToken();
        return axios.post(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices`, invoice, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async updateInvoice(mainMeterId, invoiceId, invoice) {
        const token = await this.getToken();
        return axios.put(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/${invoiceId}`, invoice, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getInvoicesByMainMeter(mainMeterId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async deleteInvoice(mainMeterId, invoiceId) {
        const token = await this.getToken();
        return axios.delete(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/${invoiceId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    // User
    async addUser(userData) {
        const token = await this.getToken();
        return axios.post(USER_API_BASE_URL, userData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getMeterReadings(mainMeterId, subMeterId, startDate, endDate) {
        const token = await this.getToken();

        // Parametreleri yalnızca tanımlı olduğunda query'ye ekle
        const params = {};
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        if (subMeterId) params.subMeterId = subMeterId;

        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/meter-readings`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: params
        });
    }

    async getMeterReadingsTimeline(mainMeterId, subMeterId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}/meter-readings/time-line`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getMeterReading(mainMeterId, subMeterId, meterReadingId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}/meter-readings/${meterReadingId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }


    async getMeterReadingsBySubMeter(mainMeterId, subMeterId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}/meter-readings`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async createMeterReading(mainMeterId, subMeterId, meterReading) {
        const token = await this.getToken();
        return axios.post(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}/meter-readings`, meterReading, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async updateMeterReading(mainMeterId, subMeterId, meterReadingId, meterReading) {
        const token = await this.getToken();
        return axios.put(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}/meter-readings/${meterReadingId}`, meterReading, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async deleteMeterReading(mainMeterId, subMeterId, meterReadingId) {
        const token = await this.getToken();
        return axios.delete(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/sub-meters/${subMeterId}/meter-readings/${meterReadingId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }


    async getUnallocatedInvoices(mainMeterId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/unallocated`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getSubMetersWithMeterReadingsByInvoiceId(mainMeterId, invoiceId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/${invoiceId}/meter-readings`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getSubMeterCharges(mainMeterId, invoiceId) {
        const token = await this.getToken();
        return axios.get(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/${invoiceId}/sub-meter-charges`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async allocateSubMeterConsumptions(mainMeterId, invoiceId, allocateSubMeterConsumptionRequest) {
        const token = await this.getToken();
        return axios.post(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/${invoiceId}/allocate-sub-meter-consumptions`, allocateSubMeterConsumptionRequest, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async cancelAllocation(mainMeterId, invoiceId) {
        const token = await this.getToken();
        return axios.delete(`${MAIN_METER_API_BASE_URL}/${mainMeterId}/invoices/${invoiceId}/cancel-allocation`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }


    async getUtilityCompanyByCity(cityEnum) {
        return axios.get(`${API_BASE_URL}/public/utility-companies/by-city`, {
            params: { city: cityEnum }
        });
    }




    async getAllCompanies() {
        return axios.get(`${API_BASE_URL}/public/utility-companies`, {
        });
    }



}

export default new SiteService();
